import { getAuthUser, getAuthToken, getAuthEmail } from "./cookieService";

export const localStorageSetter = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const localStorageGetter = (key) => {
  const storedValue = localStorage.getItem(key)
    ? JSON.parse(localStorage.getItem(key))
    : null;
  return storedValue;
};

/**
 * Get user details from cookies (for cross-subdomain auth)
 * @returns {import("./cookieService").UserDetails | null}
 */
export const getUserDetails = () => {
  // First check cookies (for cross-subdomain auth)
  const cookieUser = getAuthUser();
  return cookieUser || null;
};

/**
 * Checks if the current user's auth token is still valid (exists and not expired)
 * @returns {boolean}
 */
export const isTokenValid = () => {
  const userDetails = getUserDetails();
  if (!userDetails || !userDetails.token) return false;

  const { expiresIn } = userDetails;
  if (!expiresIn) return false;

  return new Date(expiresIn) > new Date();
};

export const getUnAuthenticatedUserDetails = () => {
  const user = localStorage.getItem("unAuthenticatedUserDetails");
  if (user) {
    const parseUser = JSON.parse(user);
    return parseUser;
  }
  return null;
};

export const resetTimer = () => {
  localStorage.removeItem("startTime");
  localStorage.removeItem("isActive");
};

/**
 * Get auth token from cookies
 * @returns {string | null}
 */
export const getToken = () => {
  // First check cookies (for cross-subdomain auth)
  const cookieToken = getAuthToken();
  return cookieToken || null;
};

/**
 * Get user email from cookies
 * @returns {string | null}
 */
export const getEmail = () => {
  // First check cookies (for cross-subdomain auth)
  const cookieEmail = getAuthEmail();
  return cookieEmail || null;
};

export const getConnectionId = () => {
  const connectionId = localStorage.getItem("connectionId");
  return connectionId ?? "";
};

export const getProjectorConnectionId = () => {
  const connectionId = localStorage.getItem("projectorConnectionId");
  return connectionId ?? "";
};

export const getPresentationId = () => {
  const presentationId = localStorage.getItem("presentationId");
  return presentationId ?? "";
};

export const beginViewerJourney = () => {
  localStorage.setItem("hasViewerJourney", true);
};

export const stopViewerJourney = () => {
  localStorage.setItem("hasViewerJourney", false);
};

export const hasViewerJourneyBegan = () => {
  return JSON.parse(localStorage.getItem("hasViewerJourney", true) ?? false);
};

export const getUnlockedSlides = () => {
  return JSON.parse(localStorage.getItem("unlockedSlides")) ?? [];
};
export const getViewersJourney = () => {
  return JSON.parse(localStorage.getItem("viewersJourney")) ?? [];
};

export const setUnlockedSlides = (id, docId, slideNumber) => {
  //NAVIGATING ACCORDING TO PRESENTER'S MOVEMENT

  // let slides = getUnlockedSlides();
  // let lastEntry = slides?.[slides?.length - 1];
  // if (lastEntry?.docId === docId && lastEntry?.slideNumber === slideNumber) {
  //   return;
  // }
  // slides.push({ id, docId, slideNumber: slideNumber ?? 0 });
  // let newSlides = [...new Set(slides)];
  // localStorage.setItem("unlockedSlides", JSON.stringify(newSlides));
  // if (!hasViewerJourneyBegan()) {
  //   setViewersJourney({ docId, slideNumber: slideNumber ?? 0 });
  // }

  ////////////////////

  //SORT NAVIGATION ACCORDING TO HERACHY OF PLAYLIST

  let slides = getUnlockedSlides();
  const isExist = slides.filter((slide) => {
    return slide?.docId === docId && slide?.slideNumber === slideNumber;
  });

  if (isExist?.length > 0) return;
  slides.push({ id, docId, slideNumber: slideNumber ?? 0 });

  let newSlides = slides?.sort((a, b) => {
    if (a.docId < b.docId) return -1;
    if (a.docId > b.docId) return 1;
    if (a.slideNumber < b.slideNumber) return -1;
    if (a.slideNumber > b.slideNumber) return 1;
    return 0;
  });
  localStorage.setItem("unlockedSlides", JSON.stringify(newSlides));
  if (!hasViewerJourneyBegan()) {
    setViewersJourney({ docId, slideNumber: slideNumber ?? 0 });
  }

  /////
};

export const setViewersJourney = (slide) => {
  let slides = getViewersJourney();
  slides.push(slide);
  slides = Array.from(new Set(slides.map((item) => JSON.stringify(item)))).map(
    (str) => JSON.parse(str),
  );
  localStorage.setItem("viewersJourney", JSON.stringify(slides));
};

export const resetUnlockedSlides = () => {
  localStorage.setItem("unlockedSlides", JSON.stringify([]));

  localStorage.setItem("viewersJourney", JSON.stringify([]));
  stopViewerJourney();
};

export const setPresenterActiveDocumentId = (id) => {
  localStorage.setItem("presenterActiveDocId", id);
};

export const getPresenterActiveDocumentId = () => {
  return localStorage.getItem("presenterActiveDocId");
};
